import { HTTP } from '../http.js'

export default {
    post(tradera_user) {
        return HTTP.post('/tradera_stores/connect_request', {
            tradera_user
        });
    },

    put(id) {
        return HTTP.put(`/tradera_stores/connect_request/${id}`);
    }
};
